module.exports = __webpack_public_path__ + "img/BCBC.b3dfe3dc.svg";